import * as React from "react";
const SvgConnectionBad = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.06,12.74h0a1.26,1.26,0,0,0-.92.38,1.28,1.28,0,0,0-.38.92,1.3,1.3,0,1,0,1.3-1.3Z" }), /* @__PURE__ */ React.createElement("path", { d: "M12,8.64a6.46,6.46,0,0,0-4.57,1.9l-.29.29,1.53,1.53.29-.3a4.31,4.31,0,0,1,6.12,0l.29.3,1.53-1.53-.29-.29A6.46,6.46,0,0,0,12,8.64Z" }));
export default SvgConnectionBad;
